module.exports = __webpack_public_path__ + "img/add-table@2x.a948e88a.png";